<template>
  <div class="container">
    <div class="head">
      <div class="head__fixed">
        <div class="head__fixed__box">
          <div class="header__fixed__left"><a href="javascript:history.go(-1)" class="back"></a></div>
          <div class="header__fixed__center">
            <h1>激活码购买成功</h1>
          </div>
          <div class="header__fixed__right"></div>
        </div>
      </div>
    </div>
    <div v-show="loaded" class="fxs">
      <div class="fxs_title">您的激活码信息如下：</div>
      <div class="fxs_cont">
        <div class="fxb_item">
          <div class="fxb_item_left">
            <div class="fxb_item_left_title">
              <!-- <img v-show="card_select == 2" class="fxb_item_left_title_icon" src="../../../assets/images/fenxiao/fx_choose_sport_yes.png" />
              <img v-show="card_select != 2" class="fxb_item_left_title_icon" src="../../../assets/images/fenxiao/fx_choose_sport_no.png" /> -->
              {{active_detail.cards_name}}
            </div>
            <div v-if="active_detail.total_fee==1188" class="fxb_item_left_stitle">每月免费使用1次预约权益，共计12次</div>
            <div v-else-if="active_detail.total_fee==3888" class="fxb_item_left_stitle">每周免费使用1次预约权益，共计52次</div>
            <div class="fxb_item_left_stitle">超出单价 五折/次，嘉宾 五折/次</div>
          </div>
          <div class="fxb_item_right">
            <div class="fxb_item_right_title">¥ {{active_detail.total_fee}}</div>
            <div v-if="active_detail.total_fee==1188" class="fxb_item_right_stitle">预估收益 :  ¥118.8</div>
            <div v-else-if="active_detail.total_fee==3888" class="fxb_item_right_stitle">预估收益 :  ¥388.8</div>
            <div v-else class="fxb_item_right_stitle">预估收益 :  ¥28.8</div>
          </div>
          <div class="clearboth"></div>
        </div>
        <div class="fxb_code">
          <div class="fxb_code_title">
            激活码
            <div>未使用</div>
          </div>
          <div class="fxb_code_code">
            <div class="fxb_code_code_num">{{active_detail_code}}</div>
            <div class="fxb_code_code_num fxb_code_code_numun" id="success_form_input">{{active_detail.code}}</div>
            <div class="fxb_code_code_copy" ref="copy" data-clipboard-action="copy" data-clipboard-target="#success_form_input" @click="copyVerifyCode()">复制</div>
            <div class="clearboth"></div>
          </div>
          <div class="fxb_code_tip">请将该码发给您的意向客户，客户激活后您将获得分销收益</div>
          <div class="fxb_code_date">购买日期：{{active_detail.create_time}}</div>
        </div>
      </div>
    </div>
    <div v-show="loaded" class="fxs_back">
      <div @click="backprev()" class="fxs_back_btn">继续购买</div>
      <div @click="backindex()" class="fxs_index_btn">返回首页</div>
      <div class="clearboth"></div>
    </div>
  </div>
</template>

<script>
  import {
    isPhone,
    safeTel
  } from "../../../lib/utils.js"
  export default {
    data() {
      return {
        active_detail:{},
        active_detail_code:'',
        loaded:false
      }
    },
    created() {},
    mounted() {
      this.getCdkDetail()
    },
    activated() { },
    methods: {
      // 获取激活码详情
      getCdkDetail(){
        console.log(this.$route.params.order_no)
        var $this=this
        // $this.$loading('获取详情~');
        let param = {
          token: localStorage.getItem("token"),
          order_no:this.$route.params.order_no
        }
        var qs = require('qs');
        let url = this.api.userApi.getCdkOrderDetail
        this.axios.post(url, qs.stringify(param), )
        .then((result) => {
          console.log(result)
          $this.active_detail=result.data
          var value=result.data.code
          $this.active_detail_code=value.slice(0,4)+' '+value.slice(4,8)+' '+value.slice(8,12)+' '+value.slice(12,value.length)
          $this.loaded=true


        }).catch((error) => {
          console.log(error)
        })
      },
      // 返回上一页
      backprev(){
        this.$router.go(-1)
      },
      backindex(){
        var url=encodeURI(window.location.href)
        if(url.indexOf('test')==-1){
          window.location.href='https://agency.unionfit.cn'
        }else{
          window.location.href='https://test.agency.unionfit.cn'
        }
      },
      // 复制功能
      copyVerifyCode(){
        let $this = this;
        // this.copyBtn = new this.clipboard(this.$refs.copy);
        let clipboard = new this.clipboard('.fxb_code_code_copy');
        clipboard.on('success', function() {
          // console.log('复制成功')
          $this.$toast('复制成功')
        });
        clipboard.on('error', function() {
          $this.$toast('请重新复制')
        });
      }
    },
    destroyed: function() {}
  }
</script>

<style lang="less" scoped="scoped">
  @vm_base: 1/750*100vw;
  .fxs{
    width: 100%;
    padding: 50*@vm_base 24*@vm_base 0 24*@vm_base;
    .fxs_title{
      width: 100%;
      font-size: 28*@vm_base;
      font-weight: 400;
      color: #333333;
      line-height: 33*@vm_base;
      padding-bottom: 220*@vm_base;
    }
    .fxs_cont{
      width: 100%;
      background: #FFFFFF;
      box-shadow: 0px 4*@vm_base 20*@vm_base 0px #EEEEEE;
      .fxb_item{
        width: 100%;
        margin-top: -190*@vm_base;
        background: #FFFFFF;
        box-shadow: 0px 4*@vm_base 20*@vm_base 0px #EEEEEE;
        border-radius: 12*@vm_base;
        padding: 40*@vm_base 30*@vm_base;
        margin-bottom: 30*@vm_base;
        .fxb_item_left{
          width: calc(68% - 1*@vm_base);
          float: left;
          height: 120*@vm_base;
          border-right: 1*@vm_base solid #EBEBEB;
          .fxb_item_left_title{
            width: 100%;
            font-size: 32*@vm_base;
            font-weight: bold;
            color: #333333;
            margin-bottom: 22*@vm_base;
            height: 32*@vm_base;
            line-height: 32*@vm_base;
            .fxb_item_left_title_icon{
              width: 32*@vm_base;
              float: left;
              margin-right: 16*@vm_base;
            }
          }
          .fxb_item_left_stitle{
            width: 100%;
            height: 30*@vm_base;
            font-size: 22*@vm_base;
            font-weight: 400;
            color: #7C7987;
            line-height: 30*@vm_base;
            margin-top: 4*@vm_base;
          }
        }
        .fxb_item_right{
          width: 32%;
          float: left;
          height: 120*@vm_base;
          .fxb_item_right_title{
            width: calc(100% + 30*@vm_base);
            text-align: center;
            font-size: 32*@vm_base;
            font-weight: bolder;
            color: #333333;
            white-space: nowrap;
            padding-top: 15*@vm_base;
            padding-bottom: 15*@vm_base;
          }
          .fxb_item_right_stitle{
            width: calc(100% + 30*@vm_base);
            font-size: 22*@vm_base;
            font-weight: 400;
            color: #7C7987;
            white-space: nowrap;
            text-align: center;
            height: 30*@vm_base;
            line-height: 30*@vm_base;
          }
        }
      }
      .fxb_code{
        padding: 0 30*@vm_base 40*@vm_base 30*@vm_base;
        width: 100%;
        .fxb_code_title{
          width: 100%;
          padding: 21*@vm_base 0 29*@vm_base 0;
          // height: 32*@vm_base;
          font-size: 32*@vm_base;
          font-weight: bold;
          color: #333333;
          line-height: 32*@vm_base;
          div{
            float: right;
            height: 32*@vm_base;
            line-height: 32*@vm_base;
            font-size: 24*@vm_base;
            font-weight: 400;
            color: #B4B3BB;
          }
        }
        .fxb_code_code{
          width: 100%;
          position: relative;
          .fxb_code_code_num{
            width: calc(100% - 142*@vm_base);
            height: 80*@vm_base;
            background: #F8F9FA;
            float: left;
            line-height: 80*@vm_base;
            text-align: center;
          }
          .fxb_code_code_copy{
            width: 120*@vm_base;
            height: 80*@vm_base;
            line-height: 80*@vm_base;
            text-align: center;
            background: #7C7987;
            color: #FFFFFF;
            font-weight: 400;
            font-size: 32*@vm_base;
            float: right;
          }
          .fxb_code_code_numun{
            position: absolute;
            top: 0;
            left: 0;
            z-index: -1;
          }
        }
        .fxb_code_tip{
          width: 100%;
          font-size: 22*@vm_base;
          font-weight: 400;
          color: #8F8C98;
          line-height: 30*@vm_base;
          padding: 30*@vm_base 0 40*@vm_base 0;
          border-bottom: 1*@vm_base solid #EBEBEB;
        }
        .fxb_code_date{
          width: 100%;
          font-size: 22*@vm_base;
          font-weight: 400;
          color: #8F8C98;
          line-height: 30*@vm_base;
          padding: 40*@vm_base 0 0*@vm_base 0;
        }
      }
    }

  }
  .fxs_back{
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;padding: 0 32*@vm_base 56*@vm_base 32*@vm_base;
    .fxs_back_btn{
      width: 65%;
      float: left;
      border-radius: 12*@vm_base;
      border: 1px solid #8F8C98;
      text-align: center;
      font-size: 32*@vm_base;
      font-weight: bold;
      padding: 27*@vm_base 0;


      background: #444054;
      color: #FFFFFF;
      outline: none;

    }
    .fxs_index_btn{
      width: 30%;
      float: right;
      border-radius: 12*@vm_base;
      border: 1px solid #8F8C98;
      text-align: center;
      font-size: 32*@vm_base;
      font-weight: bold;
      color: #444054;
      padding: 27*@vm_base 0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/unpublic/fxbuycode/fxbuysuccess.vue